import React, { Component } from "react";
import { Translate } from "react-redux-i18n";

export default class AttributeDropdown extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        const { selectedProduct: product } = this.props;
    }

    renderProdAttrValues(values) {
        return _.map(values, prodAttrValue =>
            <option key={prodAttrValue.id} value={prodAttrValue.id}>{prodAttrValue.name} {parseFloat(prodAttrValue.priceAdjustment.replace("$", "")) > 0 ? "(+" + prodAttrValue.priceAdjustment + ")" : ""}</option>
        );
    }

    render() {
        const { productAttributes, selectedProduct: product, selectOption } = this.props;
        return _.map(productAttributes, prodAttr =>
            <div className="row" style={{ padding: "0px 0px 0px 15px" }}>
                {(prodAttr.attributeControlType === 1 || prodAttr.attributeControlType === 2) &&
                    <form>
                        <label style={{ fontWeight: "bold" }}>
                            {prodAttr.name}
                            <select style={{ WebkitAppearance: "menulist" }} onChange={e => selectOption(e.target.value)}>
                                {!prodAttr.defaultValue &&
                                    <option key={"selectDefault_" + prodAttr.name} value="0">Select...</option>
                                }
                                {this.renderProdAttrValues(prodAttr.values)}
                            </select>
                        </label>
                    </form>
                }
                {(prodAttr.attributeControlType === 50 || prodAttr.attributeControlType === 40 || prodAttr.attributeControlType === 45) && optionClicked === prodAttr.conditionValue &&
                    <p>{prodAttr.textPrompt}</p>
                }
            </div>

        )
    }
}